export default __webpack_public_path__ + "static/media/Pcover.c044c2a4.png";